module.exports = __webpack_public_path__ + "img/no-data.cb6167d8.png";